// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
type StorageProvider = {
  name: string
  authProviders: string[]
  display: string
  loginParams?: object
  serviceName: string
  service: any
  active?: boolean
  order?: boolean
  canLoginManually?: boolean
}

class CloudStorageService {
   $authEvents: any
   $log: any
   $q: any
   authService: any
   configs: any
   featureAuthentication: any
   fire: any
   googleApi: any
   hooksService: any
   i18n: any
   microsoftApi: any
   providers: StorageProvider[]
   scope: any
   summonUserService: any
   constructor($rootScope: any, configs: any, store: any, i18n: any, hooksService: any, googleApi: any, microsoftApi: any, summonUserService: any, $log: any, $q: any, authService: any, $authEvents: any) {
      this.loginSuccessHandler = this.loginSuccessHandler.bind(this)
      this.logoutSuccessHandler = this.logoutSuccessHandler.bind(this)
      this.init = this.init.bind(this)
      this.signIn = this.signIn.bind(this)
      this.signOut = this.signOut.bind(this)
      this.isSignedIn = this.isSignedIn.bind(this)
      this.signedInProvider = this.signedInProvider.bind(this)
      this.signedInProviderService = this.signedInProviderService.bind(this)
      this.getFileId = this.getFileId.bind(this)
      this.getFileContents = this.getFileContents.bind(this)
      this.writeToFile = this.writeToFile.bind(this)
      this.handleApiError = this.handleApiError.bind(this)
      this.getProviders = this.getProviders.bind(this)
      this.i18n = i18n
      this.hooksService = hooksService
      this.googleApi = googleApi
      this.microsoftApi = microsoftApi
      this.summonUserService = summonUserService
      this.$log = $log
      this.$q = $q
      this.authService = authService
      this.$authEvents = $authEvents
      this.configs = configs.data.savedSearchAndItems

      this.providers = [{
         name: 'google',
         authProviders: ['google'],
         display: 'Google',
         loginParams: { useProviderStorage: configs.data.google.useProviderStorage},
         serviceName: 'googleApiService',
         service: this.googleApi
      }
      , {
         name: 'microsoft',
         authProviders: ['microsoft'],
         display: 'Microsoft',
         loginParams: { useProviderStorage: configs.data.microsoft.useProviderStorage},
         serviceName: 'microsoftApiService',
         service: this.microsoftApi
      }
      , {
         name: 'summon',
         authProviders: ['saml'],
         display: 'Summon',
         serviceName: 'summonUserService',
         service: this.summonUserService,
         loginParams: {}
      }
      ]
      this.scope = {
         userDisplay: '',
         providers: [],
         isSignedIn: this.isSignedIn,
         signedInProvider: this.signedInProvider
      }

      // this piggybacks on the authenticationService, so we listen to the events from there to know if we are logged in etc.
      $rootScope.$on(this.$authEvents.LOGINSUCCESS, this.loginSuccessHandler)
      $rootScope.$on(this.$authEvents.LOGOUTSUCCESS, this.logoutSuccessHandler)

      // it uses hooks because googleApi service needs it, so left in for legacy purposes
      this.hooksService.setHooks(this, 'CloudStorageService', ['signIn', 'signOut'], true)

      this.init()
   }

   loginSuccessHandler(event: any, args: any) {
      return _.each(this.scope.providers, (p: any) => {
         if (p.authProviders.includes(args.provider)) {
            return p.service.loginSuccessHandler(event, args)
         }
      })
   }

   logoutSuccessHandler(event: any, args: any) {
      return _.each(this.scope.providers, (p: any) => {
         if (p.authProviders.includes(args.provider)) {
            return p.service.logoutSuccessHandler(event, args)
         }
      })
   }

   init() {
      if ((this.configs.itemsEnabled || this.configs.searchEnabled) && (this.configs.providers.length > 0)) {
         this.featureAuthentication = this.authService.registerFeature('cloudStorage', 'SAVE_SEARCH_AND_ITEM', 'SAVE_SEARCH_DESCRIPTION')
      }
    
      for (var provider of this.providers) {
         if (_.contains(this.configs.providers, provider.name)) {
            provider.active = true
            provider.order = this.configs.providers.indexOf(provider.name)
            if (this.featureAuthentication) {
               for (var authProvider of provider.authProviders) {
                  this.featureAuthentication.setProvider(authProvider, provider.loginParams)
               }
            }
            provider.service.init()

            // userService gets the name of the authentication provider login
            if (provider.service.scope.providerDisplayName) {
               provider.display = provider.service.scope.providerDisplayName
            }
            provider.canLoginManually = provider.service.scope.canLoginManually === false ? false : true // true by default
            provider.service.on('initSuccess', () => {
               return this.fire('signIn')
            })
            provider.service.on('initFailed', () => {
               return this.fire('signOut')
            })
            provider.service.on('signOut', () => {
               return this.fire('signOut')
            })
         }
      }
      return this.scope.providers = _.chain(this.providers).filter((p: any) => p.active).sortBy('order').value()
   }

   signIn(name: any) {
      const currentProvider = _.find(this.scope.providers, (p: any) => p.name === name)
      if (currentProvider != null) {
         return this.authService.login('cloudStorage', currentProvider.authProviders[0])
      } else {
         return this.$log.error('Invalid provider:', name)
      }
   }

   signOut(name: any) {
      const currentProvider = _.find(this.scope.providers, (p: any) => p.name === name)
      return this.authService.openLogoutDialog('cloudStorage', currentProvider.authProviders[0])
   }

   isSignedIn() {
      return !!this.signedInProvider()
   }

   signedInProvider() {
      return this.signedInProviderService()?.scope
   }

   signedInProviderService() {
      // get logged in provider for this service from the auth provider
      const loggedInProvider = this.authService.getLoggedInProviderForFeature('cloudStorage')
      if (loggedInProvider) {
         return _.find(this.scope.providers, (p: any) => p.authProviders.includes(loggedInProvider))?.service
      } else { 
         return null
      }
   }

   getFileId(filename: any) {
      return this.signedInProviderService().getFileId(filename).catch((err: any) => this.handleApiError(err))
   }

   getFileContents(fileId: any, type?: string) {
      return this.signedInProviderService().getFileContents(fileId, type).catch((err: any) => this.handleApiError(err))
   }

   // writes data to the user's app file - will overwrite the entire file's contents
   writeToFile(data: any, fileId: any, type: string, isDelete: any) {
      return this.signedInProviderService().writeToFile(data, fileId, type, isDelete)
   }

   handleApiError(error: any) {
      if (error instanceof Error) {
      // error is returned by api implementation -- add name if it doesn't exist
         if (!error.hasOwnProperty('name')) { error.name = 'cloudStorageApiError' }
         error.message =  this.i18n.translations.CLOUD_STORAGE_API_ERROR + ': ' + error.name
      }

      return this.$q.reject(error)
   }
   getProviders() {
      return this.providers
   }
}

CloudStorageService.$inject = ['$rootScope', 'configService', 'storeService', 'translationService', 'hooksService', 'googleApiService', 'microsoftApiService', 'summonUserService', '$log', '$q', 'authenticationService', '$authEvents']

angular.module('summonApp.services')
   .service('cloudStorageService', CloudStorageService)
